<template>
  <div>
    <h5><small>Anlık Kullanım</small></h5>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-select size="mini" v-model="Mikrotik" :disabled="!Naslar" @change="MikrotikSecimi" filterable clearable
               placeholder="Port Seçiniz">
      <el-option-group
        v-for="n in Naslar"
        :key="n.Nas"
        :label="n.Nas">
        <el-option
          v-for="p in n.Portlar"
          :key="p.name"
          :label="p.name"
          :value="p.value">
        </el-option>
      </el-option-group>
    </el-select>
    <apexchart v-if="Harekets" width="100%" height="250" type="area" :options="chartOptions"
               :series="series"></apexchart>
  </div>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    props: ['Bina_id'],
    components: {Yukleniyor},
    data() {
      return {
        series: null,
        chartOptions: null,
        Naslar: null,
        Hareket: null,
        Mikrotik: null,
        lo: false,
        Harekets: [],
        Kapat: true
      }
    },
    methods: {
      /*
      startInterval: function () {
        setInterval(() => {
         // this.PortCek();
        }, 1000);
      },
      */
      MikrotikSecimi() {
        this.Harekets = [];
        this.Hareketsr = [];
        this.PortCek();
      },
      PortCek() {
        if (this.Mikrotik) {
          this.$store.dispatch("Post", {Data: this.Mikrotik, path: '_radius/interface/'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Hareket = response.Hareket;
                this.Harekets.push(this.Hareket.Tx);
                this.Hareketsr.push(this.Hareket.Rx);
                if (this.Harekets.length > 10) {
                  this.Harekets.splice(0, 1);
                  this.Hareketsr.splice(0, 1);
                }
                setTimeout(() => {
                  this.PortCek();
                  this.GrafikCalistir();
                }, 1000);

              } else {
                this.$message.error(response.Mesaj);
              }
            });
        } else {
          this.Harekets = [];
          this.Hareketsr = [];
        }
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_radius/nas/' + this.Bina_id + '/liste'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Naslar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
            }
          });

      },
      GrafikCalistir() {
        this.series = [
          {
            name: "Tx",
            data: this.Harekets
          },
          {
            name: "Rx",
            data: this.Hareketsr
          }
        ];
        this.chartOptions = {
          stroke: {
            width: [4, 4]
          },
          chart: {
            height: 250,
            type: "line",
            stacked: false,
            fontFamily: 'Google Sans,Helvetica, Arial, sans-serif'
          },
          dataLabels: {
            enabled: true
          },
          tooltip: {
            shared: false,
            intersect: false,
            x: {
              show: false
            }
          },
          legend: {
            show: false,
            position: 'bottom',
          },

        }
      }


    },
    created() {
      this.SayfaYukle();
      this.GrafikCalistir();
    },
    destroyed() {
      this.Harekets = [];
      this.Hareketsr = [];
      this.Mikrotik = null;
    }
  }
</script>

<style scoped>
  h5 {
    margin-top: 10px;
    padding: 5px;
    background: #eceef6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/NasList.vue